import React, { Fragment, useEffect, useState } from "react";
import { SolidButton } from "../../../global/SolidButton";
import {
  CalendarDays,
  Check,
  CircleCheckBig,
  Coins,
  Eye,
  EyeClosed,
  Plus,
  Trash2,
  X,
} from "lucide-react";
import toast, { Toaster } from "react-hot-toast";

import { PencilSimpleLine } from "phosphor-react";
import { MyModal } from "../../../global/MyModal";
import {
  addPayout,
  deletePayout,
  getPayout,
  updatePayout,
  updatePayoutStatus,
} from "../api";
import MyLoader from "../../../util/MyLoader";
import Pagination from "../../../util/Pagination";
import { formatDateTime } from "../../../util/MDate";
import { BorderButton } from "../../../global/BorderButton";
import amazonImg from "../../../../assets/images/amazon.png";
import bgmiImg from "../../../../assets/images/bgmi.jpeg";
import googleImg from "../../../../assets/images/google.png";
import upiImg from "../../../../assets/images/upi.png";
//import paypalImg from "../../../../assets/images/paypal.png";
import freefireImg from "../../../../assets/images/freefire.png";

export default function PayoutSetting() {
  const type = [
    { id: 1, label: "All Bonus" },
    { id: 2, label: "Active" },
    { id: 3, label: "Inactive" },
  ];

  const [activeTab, setActiveTab] = useState(1);
  const [search, setSearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // pagination states
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  const [payouts, setPayouts] = useState([]);

  //form
  const [gateway, selectGateway] = useState(null);
  const [payoutAmount, setPayoutAmount] = useState(0);
  const [requiredOffers, setRequiredOffers] = useState(0);
  const [dbClaim, setDbClaim] = useState(false);
  const [errors, setErrors] = useState({});
  const [isDisabled, setDisabled] = useState(false);
  const [currentPayoutId, setCurrentPayoutId] = useState(null);

  const validateForm = () => {
    const errs = {};
    //gateway type validation
    if (gateway === null) {
      errs.gateway = "Please select a payment gateway";
    }
    //payout amount validation
    if (!payoutAmount || payoutAmount <= 0) {
      errs.payoutAmount = "Amount must be greater than 0";
    }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };
  const fetchPayouts = async () => {
    try {
      const res = await getPayout({
        page: page,
        limit: limit,
        search: search,
        //   status: activeTab === 1 ? "public" : "private",
      });

      setPayouts(res.data?.payouts || []); // ✅ THIS LINE
      setTotal(res.data?.totalRows || 0); // ✅ FIX
    } catch (err) {
      console.error("Failed to fetch apps", err);
    } finally {
      setLoading(false);
    }
  };

  const handleStatus = async (data) => {
    try {
      const payload = {
        active: !data.active,
      };
      const dataRes = await updatePayoutStatus(data.id, payload);
      if (dataRes.status === 200) {
        fetchPayouts();
        toast.success((!data.active?"Active":"Inactive")+" successfully");
      }
    } catch (err) {
      setDisabled(false);
      console.error("Failed to add bonus", err);
    } finally {
      setLoading(false);
    }
  };

  const handleVisibility = async (data) => {
    try {
      const payload = {
        status: !data.status,
      };
      const dataRes = await updatePayoutStatus(data.id, payload);
      if (dataRes.status === 200) {
        fetchPayouts();
        toast.success((!data.status ? "Visible" : "Invisible") + " successfully");
      }
    } catch (err) {
      setDisabled(false);
      console.error("Failed to add bonus", err);
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!validateForm()) return;

    const payload = {
      gateway: gateway,
      amount: Number(payoutAmount),
      required_offers: Number(requiredOffers),
      daily_bonus: dbClaim,
    };
    const addNewPayout = async () => {
      try {
        setDisabled(true);
        const dataRes = isEditMode
          ? await updatePayout(currentPayoutId, payload)
          : await addPayout(payload);

        if (dataRes.status === 200 || dataRes.status === 201) {
          // refresh list
          const res = await getPayout({
            page: page,
            limit: limit,
            search: search,
            status: activeTab === 1 ? "active" : "inactive",
          });
          toast.success(
            isEditMode
              ? "Payout updated successfully"
              : "Payout added successfully",
          );

          setPayouts(res.data?.payouts || []);

          // close modal and reset
          setIsModalOpen(false);

          selectGateway(null);
          setPayoutAmount(0);
          setRequiredOffers(0);
          setDbClaim(false);

          setErrors({});
          setDisabled(false);
        }
      } catch (err) {
        setDisabled(false);
        console.error("Failed to add Payout", err);
        // show error toast
      }
    };
    addNewPayout();
  };

  useEffect(() => {
    fetchPayouts();
  }, [page, limit, search]);

  const handleTabClick = (id) => {
    setActiveTab(id);
  };

  // ------------------------------
  // OPEN ADD MODAL
  // ------------------------------
  const openAddModal = () => {
    setIsEditMode(false);

    // reset form when opening add modal
    selectGateway(null);
    setPayoutAmount(0);
    setRequiredOffers(0);
    setDbClaim(false);
    setErrors({});

    setIsModalOpen(true);
  };

  // ------------------------------
  // OPEN EDIT MODAL
  // ------------------------------
  const openEditModal = (payout) => {
    setIsEditMode(true);
    setIsModalOpen(true);
    setCurrentPayoutId(payout.id);
    handleUpdate(payout);
  };

  // Update
  const handleUpdate = (data) => {
    // fill form
    selectGateway(data.gateway);
    setPayoutAmount(data.amount);
    setRequiredOffers(data.required_offers);
    setDbClaim(data.dailybonus);
  };
  // ------------------------------
  // DELETE CONFIG
  // ------------------------------
  const handleDelete = async () => {
    try {
      const res = await deletePayout(deleteId);
      if (res.status === 200) {
        toast.success("Payout deleted successfully");
        // refresh list
        const res = await getPayout({
          page: page,
          limit: limit,
          search: search,
          //   status: "Active",
        });
        setPayouts(res.data?.payouts || []);
      }
    } catch (err) {
      console.error("Failed to delete payout", err);
      toast.error(err.response?.data?.error || "Failed to delete payout");
    }
    setDeleteId(null);
  };
  //Search
  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(1);
    }, 400);

    return () => clearTimeout(timer);
  }, [search]);

  const pData = [
    {
      id: 1,
      name: "UPI",
      icon: upiImg,
      isSeleted: false,
    },
    {
      id: 2,
      name: "BANK",
      icon: "https://console.omnibase.in/images/bank.png",
      isSeleted: false,
    },
    // {
    //   id: 3,
    //   name: "PayPal",
    //   icon: paypalImg,
    //   isSeleted: false,
    // },
    {
      id: 4,
      name: "AMAZON_GIFTCARD",
      icon: amazonImg,
      isSeleted: false,
    },
    {
      id: 5,
      name: "GOOGLE_GIFTCARD",
      icon: googleImg,
      isSeleted: false,
    },
    {
      id: 6,
      name: "BGMI",
      icon: bgmiImg,
      isSeleted: true,
    },
    {
      id: 7,
      name: "FREEFIRE",
      icon: freefireImg,
      isSeleted: false,
    },
  ];

  const gatewayMap = Object.fromEntries(
    pData.map((item) => [item.name, item.icon]),
  );

  function getGatewayImg(name) {
    return gatewayMap[name] || "";
  }

  if (loading) return <MyLoader />;

  return (
    <Fragment>
      <Toaster />
      <div className="space-y-2">
        {/* tabs */}
        <div className="flex flex-row items-center justify-start space-x-4">
          <div
            className=" py-2 p-2 bg-slate-300/25 dark:bg-gray-700/30 backdrop-blur-xl rounded-lg   
              "
          >
            {type.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab.id)}
                className={` text-xs font-medium border 
                 mr-2
           p-1 rounded-sm transition-all duration-200 transform
           text-slate-800 dark:text-slate-300  ${
             tab.id === activeTab
               ? "bg-white dark:bg-slate-100/2 border dark:via-slate-800 dark:to-slate-900 border-slate-300"
               : "border-transparent cursor-pointer"
           }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
          {/* search */}
          <div>
            <input
              type="text"
              placeholder="Search bonus"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-[250px]  text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
            />
          </div>
          <div className="ml-auto">
            <SolidButton
              onClick={() => openAddModal()}
              children={
                <>
                  <Plus className="w-4 h-4" />
                  <span>Add Payout</span>
                </>
              }
            />
          </div>
        </div>
        {/* table */}
        <div
          className="bg-white/80 dark:bg-slate-900/80
               backdrop-blur-xl rounded-2xl  
               border border-state-200/50 dark:border-slate-700/50 
                w-full 
                pb-4
               overflow-x-auto       
               mt-4 
              "
        >
          <table className="min-w-full border-collapse ">
            <thead>
              <tr className="bg-slate-100 dark:bg-slate-800/60 border-t border-slate-300 dark:border-slate-700">
                <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 ps-4 py-3 ">
                  Gateway
                </th>
                <th className="text-center text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Amount
                </th>
                <th className="text-center text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Offer
                </th>
                <th className="text-center text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  DailyBonus
                </th>
                <th className="text-center text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Active
                </th>
                <th className="text-center text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Visibility
                </th>
                <th className="text-start pl-10 text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  DateTime
                </th>
                <th className="text-end text-xs font-semibold text-slate-600 dark:text-slate-400 py-3 pe-4">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {payouts.map((payout, index) => (
                <>
                  <tr
                    key={index}
                    className="hover:bg-slate-100 dark:hover:bg-gray-800/20 border-b border-slate-300/40"
                  >
                    <td>
                      <div className="flex items-center justify-start space-x-1 py-2 ps-2">
                        <img
                          className="w-6 h-6 rounded-md"
                          src={getGatewayImg(payout.gateway)}
                          alt="icon"
                        />
                        <span className="text-xs  text-slate-800 dark:text-slate-400 font-semibold">
                          {payout.gateway}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="flex items-center justify-center space-x-1 py-2">
                        <Coins className="w-4 h-4 text-amber-400" />
                        <span className="text-xs  text-slate-800 dark:text-slate-400 font-mono font-semibold">
                          {"₹" + payout.amount}
                        </span>
                      </div>
                    </td>
                    <td className="text-center text-xs  text-slate-800 dark:text-slate-400 font-mono font-semibold ">
                      {payout.required_offers}
                    </td>
                    <td>
                      <div className="flex items-center justify-center">
                        {payout.dailybonus ? (
                          <>
                            <CircleCheckBig className=" w-4 h-4 text-green-500 " />
                          </>
                        ) : (
                          <>
                            <X className="w-4 h-4 text-red-500" />
                          </>
                        )}
                      </div>
                    </td>
                    {/* active and inactive */}
                    <td>
                      <div className="flex items-center justify-center ">
                        <Check
                          onClick={() => handleStatus(payout)}
                          strokeWidth={4}
                          className={`w-[20px] h-[20px] p-1 rounded-md border border-slate-400 ${
                            payout.active
                              ? "bg-blue-500 text-white"
                              : "text-white/0"
                          } `}
                        />
                      </div>
                    </td>
                    {/* visibility */}
                    <td>
                      <div
                        onClick={() => handleVisibility(payout)}
                        className="flex items-center justify-center text-blue-500 cursor-pointer"
                      >
                        {payout.status ? (
                          <Eye size={16} className="" />
                        ) : (
                          <EyeClosed size={16} />
                        )}
                      </div>
                    </td>

                    <td>
                      <div className="flex items-center  justify-start ps-10 space-x-1">
                        <CalendarDays className="w-4 h-4 text-slate-500 dark:text-slate-300" />
                        <span className="text-xs text-slate-500 dark:text-slate-300 font-sans">
                          {formatDateTime(payout.date_time)}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="flex items-center justify-end space-x-4 me-4">
                        <PencilSimpleLine
                          className="w-6 h-6 text-slate-800 dark:text-slate-200 border border-slate-200 rounded-sm p-1 cursor-pointer"
                          weight="light"
                          onClick={() => openEditModal(payout)}
                        />
                        <Trash2
                          className="w-6 h-6 text-red-400 border border-slate-200 rounded-sm p-1 cursor-pointer"
                          onClick={() => setDeleteId(payout.id)}
                        />
                      </div>
                    </td>
                  </tr>
                </>
              ))}
            </tbody>
          </table>
        </div>
        <Pagination
          page={page}
          limit={limit}
          total={total}
          onPageChange={setPage}
          onLimitChange={(l) => {
            setLimit(l);
            setPage(1); // reset to first page
          }}
          fixed={true}
          constrainTo="#devices-main"
        />
      </div>
      {/* ADD / EDIT MODAL */}
      <MyModal
        isOpen={isModalOpen}
        title={isEditMode ? "Update Payout" : "Add New Payout"}
        onClose={() => setIsModalOpen(false)}
        width="600px"
      >
        <div className="space-y-2">
          {/* Gateway Type */}
          <span className="text-sm font-medium dark:text-slate-200 mt-2">
            Payment Gateway*
          </span>
          {/* Gateway cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mt-4">
            {pData.map((item, index) => (
              <>
                <div key={index} className="relative inline-block pt-2 pr-2">
                  {/* Checkmark */}
                  {gateway === item.name && (
                    <div className="absolute top-0 right-0 z-10  border-1 border-green-500 rounded-full  p-[2px]">
                      <Check className="w-4 h-4 bg-green-500 text-white rounded-full" />
                    </div>
                  )}
                  <div
                    onClick={() => {
                      selectGateway(item.name);
                      if (errors.gateway)
                        setErrors((prev) => ({ ...prev, gateway: undefined }));
                    }}
                    className={`   
                      
                      ${
                        gateway === item.name
                          ? "border-green-500 border-[2px] bg-red-400/01"
                          : " border-slate-400/50 dark:border-slate-200/20 border-[1px]  hover:border-slate-950 dark:hover:border-slate-100"
                      }                    
                   py-3
              hover:scale-[1.06]  transition-transform duration-300  origin-bottom  
                space-y-1 cursor-pointer
               rounded-lg flex flex-col items-center justify-center`}
                  >
                    <img
                      className="w-6 h-6 rounded-sm"
                      src={item.icon}
                      alt=""
                    />
                    <span className="text-slate-800 dark:text-slate-200 text-xs font-semibold font-serif">
                      {item.name}
                    </span>
                  </div>
                </div>
              </>
            ))}
          </div>
          {errors.gateway && (
            <p className="text-xs text-red-500 font-semibold my-2">
              {errors.gateway}
            </p>
          )}
          {/* Payout amount and required offer  */}
          <div className="flex  items-start justify-between space-x-8   w-full">
            {/* Payout Amount */}
            <div className="flex flex-col  md:w-1/2">
              <label className="text-sm font-medium dark:text-slate-200 mt-4">
                Payout Anount*
              </label>
              <input
                type="number"
                name="payoutAmount"
                value={payoutAmount}
                onChange={(e) => {
                  setPayoutAmount(e.target.value);
                  if (errors.payoutAmount)
                    setErrors((prev) => ({ ...prev, payoutAmount: undefined }));
                }}
                placeholder="e.g.,100,500,1000"
                className={`w-full px-2 py-2 bg-slate-100 dark:bg-slate-800 rounded-md mt-2 text-slate-800 dark:text-white text-sm placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all border
                   ${
                     errors.payoutAmount
                       ? "border-red-400"
                       : "border-slate-200 dark:border-slate-700"
                   }`}
              />
              {errors.payoutAmount && (
                <p className="text-xs text-red-500 font-semibold my-2">
                  {errors.payoutAmount}
                </p>
              )}
              <p className="text-[10px] text-gray-500 dark:text-slate-400 font-semibold mt-1">
                Enter amount in INR
              </p>
            </div>

            {/* required_offers */}
            <div className="flex flex-col md:w-1/2  ">
              <label className="text-sm font-medium dark:text-slate-200 mt-4">
                Minimum Required Offers*
              </label>
              <input
                type="number"
                name="requiredOffer"
                value={requiredOffers}
                onChange={(e) => {
                  setRequiredOffers(e.target.value);
                }}
                min={0}
                className="w-full px-2 py-2 bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-md mt-2 text-slate-800 dark:text-white text-sm placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
              />

              <p className="text-[10px] text-gray-500 dark:text-slate-400 font-semibold mt-1">
                min offers user must complete before being eligible
              </p>
            </div>
          </div>
          {/* daily bonus require */}
          <div className="space-x-2 mt-6 p-2 flex items-start justify-start rounded-lg bg-slate-300/30 dark:bg-slate-200/10 border border-slate-300 dark:border-slate-700">
            <input
              className="w-8 h-8 rounded-2xl p-0 flex items-start justify-start"
              type="checkbox"
              name="enableCoinVariation"
              //      checked={values.enableCoinVariation}
              //    value={values.enableCoinVariation}

              // onChange={handleChange}
            />

            <div className="flex flex-col items-start justify-start ">
              <h1 className="text-start text-xs  text-slate-800 dark:text-slate-200 font-bold">
                Require Daily Bonus Claim
              </h1>
              <p className="text-start text-[10px]  text-slate-700 dark:text-slate-400 font-medium font-sans">
                When enabled, users must claim their daily bonus before being
                eligible for this payout method. This encourages daily
                engagement and user retention.
              </p>
            </div>
          </div>
          {/* action buttons */}
          <div className="flex space-x-4 justify-end mt-6">
            <BorderButton onClick={() => setIsModalOpen(false)}>
              <span className="text-sm text-slate-400">Cancel</span>
            </BorderButton>
            <SolidButton
              disabled={isDisabled}
              className="px-4 py-2 text-sm space-x-2"
              onClick={() => handleSubmit()}
            >
              {isEditMode ? "Update Payout" : "Create Payout"}
            </SolidButton>
          </div>
        </div>
      </MyModal>
      <MyModal
        isOpen={!!deleteId}
        title="Delete Payout?"
        onClose={() => setDeleteId(null)}
      >
        <p className="text-sm text-slate-800 dark:text-slate-300 mt-4">
          Are you sure you want to delete this payout?
        </p>

        <div className="flex justify-end space-x-3 mt-6">
          <button
              onClick={() => setDeleteId(null)}
            className="px-4 py-2 rounded-lg bg-slate-400/20 dark:bg-slate-800 text-sm"
          >
            Cancel
          </button>

          <SolidButton onClick={handleDelete} children={<span>Delete</span>} />
        </div>
      </MyModal>
    </Fragment>
  );
}
